import { API_AUTH } from "./common";

const ThongBaoApi = {
  list: () => API_AUTH.get(`taikhoan/ThongBao`, {}),
  chiTiet: ({ id }) => API_AUTH.get(`taikhoan/ThongBao/ChiTiet?id=${id}`, {}),
  updateThongBao: ({ id }) =>
    API_AUTH.get(`taikhoan/ThongBao/Update?id=${id}`, {}),

  listThongBaoIp: () => API_AUTH.get(`taikhoan/thongbaoduyetip`, {}),
  XoaThongBaoDuyetIP: (id) => API_AUTH.post(`taikhoan/xoathongbaoduyetip?id=${id}`, {}),
  LuuDiaChiIP: (id) => API_AUTH.post(`luuDiaChiIp?Code=${id}`, {}),
  listThongBaoMornan: ({ username, pageIndex, pageSize }) => API_AUTH.get(`thong-bao/danh-sach-thong-bao?username=${username}&pageIndex=${pageIndex}&pageSize=${pageSize}`, {}),

  // TrangThai: 0 = chua doc, >= 1 = da doc, -1 = da xoa
  capNhatTrangThaiThongBao: ({ username, id, status }) =>
    API_AUTH.post(
      `thong-bao/cap-nhat-trang-thai-thong-bao?username=${username}&id=${id}&status=${status}`,
      {}
    ),

  // Tra ve { SoLuongThongBaoMoi: n } - dem cac dong TrangThai = 0
  soLuongThongBaoMoi: ({ username }) =>
    API_AUTH.get(`thong-bao/so-luong-thong-bao-moi?username=${username}`, {}),

  capNhatTrangThaiTatCa: ({ username, status }) =>
    API_AUTH.post(
      `thong-bao/cap-nhat-trang-thai-thong-bao-tat-ca?username=${username}&status=${status}`,
      {}
    ),
};

export default ThongBaoApi;
